import React, { useState } from 'react';

import { Input as AInput } from './Input';

export type TInputNumberParams = {
  max?: number;
  min?: number;
  onChange?: (value?: number) => void;
  value?: number;
  parser?: (value: number) => number;
  formatter?: (value: number) => string;
} & Omit<Parameters<typeof AInput>[0], 'onChange' | 'value'>;

export const InputNumber = ({ min, max, onChange, formatter = String, parser = Number, ...rest }: TInputNumberParams) => {
  const NUMERIC_REGEXP = /[-]?[\d]*[.]{0,1}[\d]*/g;
  const [value, setValue] = useState<string | undefined>();
  const [formattedValue, setFormattedValue] = useState<string | undefined>();
  const [isFocus, setIsFocus] = useState<boolean | undefined>();

  return (
    <AInput
      {...rest}
      onBlur={() => {
        setIsFocus(false);
        const nextValue = parser(Number(value));
        setFormattedValue(formatter(nextValue));
        if (!Number.isNaN(nextValue)) {
          setValue(nextValue.toString());
        }
        onChange?.(nextValue);
      }}
      onChange={(e) => {
        if (e.target.value) {
          let coveredValue;
          const matchedValue = e.target.value.match(NUMERIC_REGEXP) ?? [];
          const stringValue = matchedValue.length > 2 ? value : matchedValue.join('');
          const numericValue = Number(stringValue);
          if (typeof min === 'number' && numericValue < min) {
            coveredValue = min;
          } else if (typeof max === 'number' && numericValue > max) {
            coveredValue = max;
          } else {
            coveredValue = stringValue;
          }
          if (typeof coveredValue !== 'number' || !Number.isNaN(coveredValue)) {
            setValue(String(coveredValue));
          }
          if (onChange) {
            onChange(numericValue);
          }
        } else {
          setValue(undefined);
          if (onChange) {
            onChange(undefined);
          }
        }
      }}
      onFocus={() => {
        setIsFocus(true);
      }}
      value={isFocus ? value : formattedValue}
    />
  );
};
